import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import { Button, Grid, Header, Message } from 'semantic-ui-react'

// material
import { styled } from '@mui/material/styles'
import { Container, Box } from '@mui/material'
import MyTextInput from '../components/common/form/MyTextInput'
import { confirmPasswordStart } from '../redux/auth/auth.actions'

// components
import Page from '../components/Page'
import ClientMenuLeft from './common/ClientMenuLeft'

import DisplayCognitoError from '../components/common/DisplayCognitoError'
import DisplayErrorString from '../components/common/DisplayErrorString'

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}))

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0),
}))

// ----------------------------------------------------------------------

export default function ClientPasswordCode() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { currentError } = useSelector((state) => state.authReducer)
  const [errorMessage, setErrorMessage] = useState(null)
  const [passwordShown, setPasswordShown] = useState(false)

  const togglePassword = () => {
    setPasswordShown(!passwordShown)
  }
  const initialValues = {
    password: '',
    passwordConfirm: '',
    code: '',
  }

  const validationSchema = Yup.object().shape({
    code: Yup.string('Entrez votre code').required('Le code est requis'),
    password: Yup.string().required('Mot de passe est un champ obligatoire'),
    passwordConfirm: Yup.string().required(
      'Mot de passe est un champ obligatoire',
    ),
  })

  const handleSubmit = (values, { resetForm }) => {
    const payload = {
      navigate: navigate,
      password: values.password,
      code: values.code,
      username: localStorage.getItem('emailClientResetPassword'),
      redirectPath: '/login',
    }

    if (values.password !== values.passwordConfirm) {
      setErrorMessage(
        'Le nouveau mot de passe doit être pour les deux derniers champs.',
      )
      resetForm()
      return
    }

    try {
      dispatch(confirmPasswordStart(payload))
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <RootStyle title=" Administration des plaintes | Gestion des plaintes">
      <ClientMenuLeft />s
      <Container>
        <ContentStyle>
          <Box sx={{ mb: 5 }}>
            <Header as="h2" color="blue" textAlign="center">
              Entrer le code de sécurité
            </Header>
          </Box>
          <Grid textAlign="center" verticalAlign="middle">
            <Grid.Column style={{ maxWidth: 450 }}>
              <DisplayCognitoError errorMessage={currentError} />
              <DisplayErrorString errorMessage={errorMessage} />
              <Message info>
                Le code de vérification a été envoyé à votre adresse e-mail:{' '}
                {localStorage.getItem('emailClientResetPassword')}
                <p>
                  Le code expire dans 1 heure et ne peut être utilisé qu'une
                  seule.
                </p>
                fois
              </Message>
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                <Form className="ui form">
                  <MyTextInput
                    name="code"
                    label="Votre code comporte 6 chiffres"
                  />
                  <div className="ui icon input">
                    <MyTextInput
                      name="password"
                      placeholder="Votre nouveau mot de passe"
                      label="Votre nouveau mot de passe"
                      type={passwordShown ? 'text' : 'password'}
                      size="60"
                    />
                    <i
                      aria-hidden="true"
                      onClick={togglePassword}
                      className="eye link icon"
                    ></i>
                  </div>
                  <div className="ui icon input">
                    <MyTextInput
                      name="passwordConfirm"
                      placeholder="Votre nouveau mot de passe"
                      label="Votre nouveau mot de passe"
                      type={passwordShown ? 'text' : 'password'}
                      size="60"
                    />
                    <i
                      aria-hidden="true"
                      onClick={togglePassword}
                      className="eye link icon"
                    ></i>
                  </div>
                  <Button
                    type="submit"
                    fluid
                    size="large"
                    color="blue"
                    content="Continuer"
                  />
                </Form>
              </Formik>
            </Grid.Column>
          </Grid>
        </ContentStyle>
      </Container>
    </RootStyle>
  )
}
